import axios from 'axios';
import UIHelper from '../services/UIHelper';

export default function configureAxios() {
  axios.interceptors.response.use(response => {
    // TODO set toast notification for all success requests
    // response.status < 300 && UIHelper.showSuccessMessage();
    return response;
  }, error => {
    if (error?.response?.status === 422) {
      UIHelper.showRequestErrorToast();
    }
    if (error?.response?.status === 404) {
      // UIHelper.showNotFoundErrorToast();
    }
    if (error?.response?.status === 413) {
      UIHelper.showServerConfigError();
    }
    if (error?.response?.status >= 500) {
      UIHelper.showServerError();
    }
    return Promise.reject(error);
  });
}
